export const quizResultsData = {
  date: "August 17 2024",
  employeeName: "John Doe",
  managerName: "Jenny Smith",
  preparedBy: "HPE Education Services",
  executiveSummary: {
    summary:
      "John demonstrates foundational skills in HPE Ezmeral Unified Analytics but needs to deepen his understanding of advanced administrative tasks and cloud-native architecture.",
    recommendations: [
      "Enroll in Advanced HPE Ezmeral Unified Analytics Administration",
      "Take Cloud-Native Architecture eLearning",
      "Participate in HPE Ezmeral Hands-on Lab Sessions",
    ],
  },
  skillsAssessment: [
    { skill: "Python", selfAssessment: 2, desiredState: 3 },
    { skill: "Cloud Computing", selfAssessment: 5, desiredState: 4 },
    { skill: "Linux Admin", selfAssessment: 1, desiredState: 4 },
    { skill: "Architecture", selfAssessment: 3, desiredState: 5 },
    { skill: "Kubernetes", selfAssessment: 4, desiredState: 4 },
    // {
    //   skill: "HPE Ezmeral Unified Analytics",
    //   selfAssessment: 2,
    //   desiredState: 5,
    // },
    // Add more skills as needed
  ],
  learningPath: [
    {
      title: "Advanced HPE Ezmeral Unified Analytics Administration",
      duration: "25 hours",
      description:
        "Dive into advanced administration, covering security, resource management, and performance tuning.",
      options: [
        "VILT option",
        "eLearning option",
        "HPE Digital Learner Option",
      ],
    },
    {
      title: "Cloud-Native Architecture",
      duration: "15 hours",
      description: "Learn to design and manage cloud-native infrastructure.",
      options: [],
    },
    {
      title: "HPE Ezmeral Hands-on Lab Sessions",
      duration: "10 hours",
      description:
        "Participate in practical labs to gain hands-on experience with HPE Ezmeral.",
      options: [],
    },
  ],
  progressTracking: [
    "Complete Advanced HPE Ezmeral Unified Analytics Administration within 2 months.",
    "Finish Cloud-Native Architecture by the end of the quarter.",
    "Participate in HPE Ezmeral Hands-on Lab Sessions to solidify practical skills.",
  ],
  // managerialInsights: {
  //   teamSummary:
  //     "The majority of the team shows a need for cloud computing skills.",
  //   budgetRecommendations: "$10000 for team-wide cloud computing courses.",
  //   roiJustification:
  //     "Enhanced cloud skills will reduce project delays and improve service quality, leading to increased customer satisfaction.",
  // },
};
